import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/style.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
// import moment from "moment";
// import "vuetify/styles";
// import { createVuetify } from "vuetify";
// import * as components from "vuetify/components";
// import * as directives from "vuetify/directives";

// const vuetify = createVuetify({
//   components,
//   directives,
// });
import {
  faUserSecret,
  faForward,
  faBackward,
  faCheck,
  faCircleDot,
} from "@fortawesome/free-solid-svg-icons";
library.add(faUserSecret, faForward, faBackward, faCheck, faCircleDot);

window.api = process.env.VUE_APP_API;
window.qrcode = process.env.VUE_APP_QRCODE;

window.moment = require("moment");
window.$ = require("jquery");
window.Axios = require("axios");
router.afterEach(async () => {
  // vue-router หลังเปลี่ยนหน้า
  await store.dispatch("Main/SET_LOADING", false);
});

// Axios Before Request (ก่อน fatch ข้อมูล)
window.Axios.interceptors.request.use(
  (config) => {
    let Onload = store.getters["Main/_getOnload"];
    if (Onload == true) {
      store.dispatch("Main/SET_LOADING", true);
    } else if (Onload == false) {
      store.dispatch("Main/SET_LOADING", false);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Axios After Request (หลัง fatch ข้อมูล)
window.Axios.interceptors.response.use(
  function (response) {
    // ปิดหน้า loading
    store.dispatch("Main/SET_LOADING", false);
    return response;
  },
  function (error) {
    // console.log("status code : " + { ...error }.response.status);
    switch ({ ...error }.response.status) {
      case 401:
        window.Swal.fire({ ...error }.response.data.msg, "", "error").then(
          () => {
            location.href = process.env.VUE_APP_LOGIN_PATH;
          }
        );
        break;
      case 403:
        console.log({ ...error }.response.data);
        break;
      case 404:
        console.log({ ...error }.response.data);
        break;
      default:
        console.error("Axios error :", { ...error });
        break;
    }
    return Promise.reject(error);
  }
);
/* ========== [ Axios ] ========== */
createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("vue-typeahead-bootstrap", VueBootstrapTypeahead)
  .component("VueDatePicker", VueDatePicker)
  .use(VCalendar, {})
  .use(VueSweetalert2)
  .use(store)
  .use(router)
  // .use(vuetify)
  .mount("#app");
